import _sortBy from 'lodash/sortBy';
import _uniqBy from 'lodash/uniqBy';
import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import { stringForAutocomplete } from '../../search/searchHelper';

const NavigationHits = ({ hits }) => {
  let navigationHits = hits.map((hit) => ({
    ...hit,
    autocomplete: stringForAutocomplete(hit)
  }));

  navigationHits = navigationHits.filter((hit) => !!hit.autocomplete);
  navigationHits = _uniqBy(navigationHits, (hit) => hit.autocomplete.toLowerCase());
  navigationHits = navigationHits.slice(0, 5);
  navigationHits = _sortBy(navigationHits, 'autocomplete');

  return (
    <div className="ais-Hits">
      <ul className="ais-Hits-list">
        {navigationHits.map((hit) => (
          <li key={hit.id} className="ais-Hits-item">
            <a href={`/suche?q=${hit.autocomplete}`}>{hit.autocomplete}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

NavigationHits.propTypes = {
  hits: React.PropTypes.arrayOf(React.PropTypes.object)
};

NavigationHits.defaultProps = {
  hits: []
};

export default connectHits(NavigationHits);



// WEBPACK FOOTER //
// ./components/search/NavigationHits.js